import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

export const VET_USER_INCLUDES = [
  'location',
  'last-location',
  'services',
  'service-user-scores.service',
  'company',
  'image',
  'preferred-payout-account',
  'profile',
];

class AdminUserRateRoute extends Route {
  @service store;
  @service('commands/user-commands') userCommandService;

  model() {
    const { user } = this.modelFor('admin.user');

    const allServices = this.store.findAll('service');
    const userToRate = this.userCommandService.getUser(user.id, VET_USER_INCLUDES);

    return Promise.all([allServices, userToRate]).then(([allServices, user]) => ({
      allServices,
      user,
    }));
  }

  /** @inheritDoc */
  setupController(controller) {
    super.setupController(...arguments);

    const { existingAdminScores = [] } = controller;
    const existingDecimalInputs = existingAdminScores.reduce((accum, userServiceScore) => {
      // fill the decimal inputs
      accum[userServiceScore.service.id] = userServiceScore.ascore.toFixed(1).split('.').map(Number);

      return accum;
    }, {});

    controller.setProperties({
      serviceRatings: existingDecimalInputs,
      projects: []
    });

    controller.loadProjectsWaiter.perform();
    controller.loadClassificationsTask.perform();
  }

  /** @inheritDoc */
  resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (isExiting) {
      controller.loadProjectsWaiter.cancelAll({ resetState: true });
      controller.loadClassificationsTask.cancelAll({ resetState: true });
    }
  }
}

export default AdminUserRateRoute;
